import {FunctionComponent, HTMLAttributes, SVGProps} from 'react';
import {NavLink, NavLinkProps, useLocation} from 'react-router-dom';
import styled from 'styled-components';
import {LAYOUT_SIZE, palette} from '@/styles';
import {Typography} from '../Typography';

interface IProps extends Omit<NavLinkProps, 'to'> {
  icon?: FunctionComponent<SVGProps<SVGSVGElement>>;
  to?: string;
  name: string;
}

export const MenuButton = ({
  name,
  to,
  icon: Icon,
  ...props
}: IProps & HTMLAttributes<HTMLDivElement>) => {
  const location = useLocation();

  if (!name) {
    return null;
  }

  if (to?.length) {
    return (
      <Menu
        as={NavLink}
        to={{pathname: to, search: location.search}}
        {...props}
      >
        {!!Icon && <Icon className="menu-icon" />}
        <Typography variant="medium12" align="center">
          {name}
        </Typography>
      </Menu>
    );
  }

  return (
    <Menu {...props}>
      {!!Icon && <Icon className="menu-icon" />}
      <Typography variant="medium12" align="center">
        {name}
      </Typography>
    </Menu>
  );
};

const Menu = styled.div`
  cursor: pointer;
  width: 100%;
  height: ${LAYOUT_SIZE.SIDE_BAR}px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: ${palette.white};
  gap: 4px;
  &:hover {
    background-color: ${palette.gray100};
  }
  &.active {
    background-color: ${palette.teal100};
    color: ${palette.white};
    & > .menu-icon {
      color: ${palette.white};
    }
  }
`;
